import { displayCurrency } from '../../utils/Format/Format';

export const getDisclaimerNumAcctMinimums = (iClass, moneyMarket, bond) => {
    if (!iClass && !moneyMarket && !bond) {
        return '4';
    }
    if (iClass && !moneyMarket && !bond) {
        return '5';
    }
    if (!iClass && bond) {
        return '5';
    }
    if (!iClass && moneyMarket) {
        return '6';
    }
    if (iClass && bond) {
        return '6';
    }
    if (iClass && moneyMarket) {
        return '7';
    }
    return '';
};

export const disclaimerNumbersAcctMinimums = (...rest) =>
    `${getDisclaimerNumAcctMinimums(...rest)}`;

export const accountMinimumsUtil = (iClass, moneyMarket, bond) => (
    gqlResult
) => {
    if (!gqlResult) return null;
    const {
        mutualFund: {
            minimumInvestmentAmount,
            accountMinimumAddToAccount,
            accountMinimumOpenIRA,
            accountMinimumAddToIRA,
            accountMinimumSystematicPurchase
        }
    } = gqlResult;
    const title = 'Account Minimums';
    const returnData = [
        {
            label: `To open an account`,
            labelSup: `${iClass ? '*' : ''}`,
            values: [{ val1: displayCurrency(minimumInvestmentAmount) }]
        },
        {
            label: 'To add to an account',
            values: [{ val1: displayCurrency(accountMinimumAddToAccount) }]
        },
        {
            label: `To open an IRA account`,
            labelSup: `${iClass ? '*' : ''}`,
            values: [{ val1: displayCurrency(accountMinimumOpenIRA) }]
        },
        {
            label: `To add to an IRA account`,
            labelSup: disclaimerNumbersAcctMinimums(iClass, moneyMarket, bond),
            values: [{ val1: displayCurrency(accountMinimumAddToIRA) }]
        },
        {
            label: `Recurring Purchase Minimum`,
            labelSup: disclaimerNumbersAcctMinimums(iClass, moneyMarket, bond),
            values: [
                { val1: displayCurrency(accountMinimumSystematicPurchase) }
            ],
            showDefinition: false,
            definition: `A recurring deposit where the same amount each month is automatically debited from your bank account and is invested in a mutual fund.`
        }
    ];
    return { data: returnData, title };
};

export const loadFundUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const {
        mutualFund: { frontEndLoad, backEndLoad, loadHistoryText }
    } = gqlResult;
    const title = 'This is a No-Load Fund';
    const returnData = [
        {
            label: 'Front-End Load',
            values: [{ val1: frontEndLoad === 0 ? 'None' : frontEndLoad }]
        },
        {
            label: 'Back-End Load',
            values: [{ val1: backEndLoad === 0 ? 'None' : backEndLoad }]
        },
        {
            label: 'Load History',
            values: [{ val1: loadHistoryText }]
        }
    ];
    return { data: returnData, title };
};
